var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneSchoolBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 442,
    viewBox: "0 0 282 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.486 0.0292969H115.514C91.7665 0.0292969 69.7562 7.59877 51.2212 19.8264C48.3251 21.5732 48.3251 25.6491 50.642 27.9781L70.9146 48.3575C79.6029 57.0915 91.7665 60.0029 103.351 57.6738C107.405 57.0915 111.46 56.5093 115.514 56.5093H166.486C199.501 56.5093 225.566 83.2936 225.566 115.901V325.517C225.566 358.706 198.922 384.908 166.486 384.908H115.514C82.499 384.908 56.4342 358.124 56.4342 325.517V115.901C56.4342 111.825 57.0134 107.749 57.5926 103.673C59.9095 93.7744 56.4342 83.2936 48.9043 75.7241L26.894 53.5979C24.5772 51.2688 20.5226 51.2688 18.2058 54.7624C7.20062 72.8127 0.25 93.7744 0.25 116.483V326.099C0.25 390.149 51.8004 441.97 115.514 441.97H166.486C230.2 441.97 281.75 390.149 281.75 326.099V116.483C281.171 51.8511 229.62 0.0292969 166.486 0.0292969Z",
    fill: "#09BAB5",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneSchoolBg);
export default __webpack_public_path__ + "static/media/OneSchool_bg.237da550b8b9d43c8ea4a2ef5fd1a19f.svg";
export { ForwardRef as ReactComponent };